import { useQuery } from "@tanstack/react-query";
import {
  agentToolsApi,
  type MCPConnectionTool,
} from "../../../services/agent-tools-service";
import { MCP_CONNECTIONS_QUERY_KEY } from "./useMCPConnections";
import { mcpQueryKeys } from "../query-keys";
import { useMCPQueryScope, mcpRequestOptions } from "./useMCPQueryScope";

export const MCP_TOOLS_QUERY_KEY = [
  ...MCP_CONNECTIONS_QUERY_KEY,
  "tools",
] as const;

type UseMCPToolsResult = {
  tools: MCPConnectionTool[];
  isLoading: boolean;
  error: Error | null;
  isFetching: boolean;
  isStale: boolean;
};

export const useMCPTools = (id: string | null): UseMCPToolsResult => {
  const scope = useMCPQueryScope();
  const query = useQuery({
    queryKey: mcpQueryKeys.tools(scope.key, id),
    queryFn: ({ signal }) => agentToolsApi.listMCPTools(id as string, mcpRequestOptions(scope, signal)),
    enabled: scope.enabled && Boolean(id),
    staleTime: 30_000,
  });

  return {
    tools: query.data ?? [],
    isLoading: query.isLoading,
    error: query.error as Error | null,
    isFetching: query.isFetching,
    isStale: query.isStale,
  };
};
